import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Keyboard } from "swiper";
import classNames from "classnames";

import { priceFormatter } from "@/src/helpers/number-formatter";
import { createImageUrl } from "@/src/helpers/create-image-url";

import { LazyImage } from "src/components/common/lazy-image/LazyImage";
import SwiperWrapper from "src/components/swiper-wrapper";
import Container from "components/grid/container";

import styles from "./styles.module.css";
import PropTypes from "prop-types";

const SimilarRealEstateList = ({ similarRealEstateList }) => {
  const titleClass = classNames(styles.cardTitle, styles.hiddenOverflow);

  return (
    <div className={styles.sectionWrapper}>
      <Container>
        <p className={styles.sectionTitle}>Aynı Taşınmazın Diğer İlanları</p>
        <SwiperWrapper>
          <Swiper
            navigation={true}
            loop={similarRealEstateList.length > 4}
            modules={[Navigation, Keyboard]}
            slidesPerView={4}
            keyboard={{ enabled: true }}
            onInit={(swiper) => {
              swiper.el.oncontextmenu = (e) => e.preventDefault();
            }}
          >
            {similarRealEstateList.map((listingItem) => {
              const {
                price: { value, currency, alternativeValue },
                coverPhoto,
                url,
                title,
              } = listingItem || {};
              const imageUrl = createImageUrl(coverPhoto, {
                width: 520,
                height: 294,
              });
              return (
                <SwiperSlide key={listingItem?.id}>
                  <a className={styles.cardWrapper} href={url}>
                    <div className={styles.cardImageWrapper}>
                      <LazyImage src={imageUrl} alt="showcase_listing_image" className={styles.imageClass} />
                    </div>
                    <div className={styles.cardContentWrapper}>
                      <div className={titleClass}>{title}</div>
                      <span className={styles.hiddenOverflow}>
                        {value ? (
                          <span className={styles.cardPrice}>{`${priceFormatter(value)} ${currency}`}</span>
                        ) : (
                          <span className={styles.cardPrice}>{alternativeValue}</span>
                        )}
                      </span>
                    </div>
                  </a>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </SwiperWrapper>
      </Container>
    </div>
  );
};

SimilarRealEstateList.propTypes = {
  similarRealEstateList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      price: PropTypes.shape({
        value: PropTypes.number,
        currency: PropTypes.string,
        alternativeValue: PropTypes.string,
      }).isRequired,
      coverPhoto: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SimilarRealEstateList;
